// Lines rebuilt from order history (getSalesHistoryData) carry a lineId but no
// `key`. Row selection and usePOSKeyboard's key-resync match on `key`, so an
// unkeyed cart resolves every click to items[0]. Number the top-level lines the
// same way cart.js's totals recompute does (key = position).
export const assignCartLineKeys = (cart) => {
  if (!Array.isArray(cart?.items)) return cart;
  return { ...cart, items: cart.items.map((line, i) => ({ ...line, key: i })) };
};
